<script lang="ts" setup generic="Item extends { id: string; checked?: boolean }">
import DragHandleIcon from '#assets/svg/drag-handle.svg?component';
import type { SortableEvent, SortableOptions } from 'sortablejs';
import { Sortable } from 'sortablejs-vue3';
import type { AutoScrollOptions } from 'sortablejs/plugins';

const props = defineProps<{
  list: Array<Item>;
}>();

const emit = defineEmits<{
  updateList: [list: Array<Item>];
}>();

const options: SortableOptions | AutoScrollOptions = {
  animation: 150,
  handle: '.handle',
  ghostClass: 'ghost',
  dragClass: 'drag',
  scroll: true
};

const onUpdate = (event: SortableEvent) => {
  const { oldIndex, newIndex } = event;

  if (oldIndex === undefined || newIndex === undefined) {
    return;
  }

  if (oldIndex === newIndex) {
    return;
  }

  const newList = [...props.list];
  const sortedItem = newList.splice(oldIndex, 1)[0];
  if (sortedItem) {
    newList.splice(newIndex, 0, sortedItem);
  }

  emit('updateList', newList);
};
</script>

<template>
  <Sortable :list="list" item-key="id" tag="ul" class="h-md flex flex-col gap-3" :options="options" @update="onUpdate">
    <template #item="{ element }">
      <li :key="element.id" class="flex items-center px-4 py-2 gap-1" :class="{ 'bg-celeste': element.checked }">
        <DragHandleIcon class="w-5 cursor-move handle" />
        <slot name="item" :item="element" />
      </li>
    </template>
  </Sortable>
</template>

<style lang="postcss" scoped>
.ghost {
  @apply bg-celeste/15;
}
</style>
